import { useState } from 'react';

import { ConflictAlertSeverityBadge } from '../badges/ConflictAlertSeverityBadge';
import { ConflictAlertTypeBadge } from '../badges/ConflictAlertTypeBadge';

import { ModalBase } from './ModalBase';

import type { ConflictSeverityVM } from '../../view-models';

export interface ResolveModalProps {
  open: boolean;
  alert: { id: string; severity: ConflictSeverityVM; alertType: string } | null;
  /** Mutation em voo — desabilita o submit p/ evitar duplo-POST (review T7). */
  submitting?: boolean;
  onClose: () => void;
  onConfirm: (p: { reason: string }) => void;
}

// Convertido verbatim de design-references/brief-3/shared/modals-3.jsx:377-406.
export function ResolveModal({
  open,
  alert,
  submitting = false,
  onClose,
  onConfirm,
}: ResolveModalProps): React.JSX.Element | null {
  const [reason, setReason] = useState('');
  if (!open || alert === null) return null;
  // Engine ResolveConflictAlertDto.reason é @MinLength(20) — espelhamos o contrato
  // p/ evitar 400 opaco (o mockup dizia "opcional", mas o backend exige). Igual ao
  // FalsePositiveModal.
  const canSubmit = reason.trim().length >= 20 && !submitting;
  return (
    <ModalBase
      open={open}
      onClose={onClose}
      title="Resolver alerta (contexto mudou)"
      width={520}
      footer={
        <div style={{ display: 'flex', gap: 8, marginLeft: 'auto' }}>
          <button type="button" className="btn-ghost-mini" onClick={onClose}>
            Cancelar
          </button>
          <button
            type="button"
            className="btn-ghost-mini btn-ghost-mini--primary"
            disabled={!canSubmit}
            onClick={() => onConfirm({ reason })}
          >
            Resolver
          </button>
        </div>
      }
    >
      <div className="modal-form">
        <div className="modal-form__alert-head">
          <ConflictAlertSeverityBadge severity={alert.severity} />
          <ConflictAlertTypeBadge alertType={alert.alertType} />
        </div>
        <div className="modal-form__callout">
          Use quando o contexto mudou e o alert não é mais relevante (Bond arquivado, parties não
          interagem mais, etc).
        </div>
        <label className="modal-form__field">
          <span className="modal-form__label">Razão (mínimo 20 caracteres)</span>
          <textarea
            className="modal-form__textarea"
            value={reason}
            onChange={(e) => setReason(e.target.value)}
            rows={3}
            placeholder="Bond foi arquivado em 2026-05-14; parties não interagem mais."
          />
          <span className="modal-form__hint">{reason.trim().length}/20 mínimo</span>
        </label>
      </div>
    </ModalBase>
  );
}
